


export type FibuAccountType = 'Normal' | 'CostType' | 'InternalSettlement';

export const FibuAccountType = {
    Normal: 'Normal' as FibuAccountType,
    CostType: 'CostType' as FibuAccountType,
    InternalSettlement: 'InternalSettlement' as FibuAccountType
};

